import type { ICustomFieldDefinition, IFieldDefinition, IRecordTypeDefinition, IRecordTypeOverride } from '@platform/core/types';
import type { IBuilderFieldRow } from './IBuilderFieldRow';

/** Системні поля платформи (ADR-023): тип і приховування заборонені. */
const SYSTEM = ['title', 'status', 'tags', 'rank', 'area', 'iteration'];

/** Власне поле як поле визначення (до того, як сервер поверне злите визначення): `checkbox` → `boolean`, `pii` — як у власного поля. */
export function fieldOfCustom(c: ICustomFieldDefinition): IFieldDefinition {
  return {
    key: c.key, label: c.label, type: c.type === 'checkbox' ? 'boolean' : c.type, required: c.required, inList: c.inList, width: c.width ?? null,
    options: c.options?.map((o) => ({ value: o.value, label: o.label ?? null })), storage: 'ext', pii: !!c.pii,
  } as IFieldDefinition;
}

/**
 * Рядки «Полів» конструктора (прототип v4 bFields): поля злитого визначення без службових (hidden) і без тих, що патч щойно приховав чи
 * вилучив; власні поля патча, яких злите визначення ще не має, — наприкінці (зміна зберігається). Чиста функція.
 */
export function builderFieldRows(rt: IRecordTypeDefinition, published: IRecordTypeDefinition | undefined, patch: IRecordTypeOverride): IBuilderFieldRow[] {
  const custom = new Map((patch.customFields ?? []).map((f) => [f.key, f]));
  const rows: IBuilderFieldRow[] = rt.fields
    .filter((f) => !f.hidden && !patch.fields?.[f.key]?.hidden && !(f.storage === 'ext' && !custom.has(f.key)))
    .map((f) => {
      const pub = published?.fields.find((p) => p.key === f.key);
      return { field: f, custom: custom.get(f.key), override: patch.fields?.[f.key], published: pub, system: !!f.system || SYSTEM.includes(f.key), lockedRequired: !!pub?.required };
    });
  for (const c of custom.values()) if (!rt.fields.some((f) => f.key === c.key)) rows.push({ field: fieldOfCustom(c), custom: c, system: false, lockedRequired: false });
  return rows;
}

/** Спроєктовані поля, приховані в цьому просторі (патч `hidden`), — для «Показати» під таблицею полів. Чиста функція. */
export function hiddenFields(published: IRecordTypeDefinition | undefined, patch: IRecordTypeOverride): IFieldDefinition[] {
  return (published?.fields ?? []).filter((f) => patch.fields?.[f.key]?.hidden);
}
